import { useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import { ContentHeaderView } from "components/shared";
import React from "react";
//import NonNachaTemplateListTable from "./components/NonNachaTemplateListTable";
//import MobileNonNachaTemplateListTable from "./components/MobileNonNachaTemplateListTable";
import { SecondaryButton } from "components/ui";
import TASPositivePayImportChecksTemplateListTable from "./components/TASPositivePayImportChecksTemplateListTable";
import "./styles.css";

/**
 * @function TASPositivePayImportChecksTemplateListWidget
 * @return {React.Component}
 * @exported true
 * @description This is the Non Nach Template List table widget for the NonNachaFileImportPage.
 */
export default function TASPositivePayImportChecksTemplateListWidget(props) {
    const { data, ui } = useStateManager();
    const hasTemplates = data.templates.length > 0;
    const navigate = useRoute();

    const onCreateNewTemplate = evt => {
        navigate("/tasPositivePayCreateTemplate");
    };

    return (
        <div className="tas-positive-pay-import-checks-template-list-widget">
            <ContentHeaderView text="Template List" />
            <div className="">
                { hasTemplates && 
                <div className="flex-container add-link-container">
                    <a className="clickable add-link set-width" onClick={ onCreateNewTemplate }>+ Add</a>
                </div> 
                }
                <TASPositivePayImportChecksTemplateListTable />
                <div className="flex-container flex-horizontal align-center button-row-container">
                    <div className="flex-width"></div>
                    <div className="set-width">
                        { !hasTemplates && 
                        <SecondaryButton text="Create a New Template"
                        dataPoint={ `TAS_Positive_Pay_ImportChecks_Template_List_Widget_Create_New_Template_Button` }
                        onClick={ onCreateNewTemplate } /> }
                    </div>
                    <div className="flex-width"></div>
                </div>
                
            </div>
            <div className="show-on-mobile">
                {/*<MobileNonNachaTemplateListTable />*/}
            </div>
        </div>
    )
}
